/**
 * Builds the query string for the conversation-history endpoint.
 * Only company_id is required — the backend identifies the candidate
 * via the session cookie (authMiddleware), so no session_id is needed.
 */
export function buildConversationQueryParams(companyId) {
    return new URLSearchParams({ company_id: companyId });
}
